import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import { useCustomSnackbar } from '../../hooks/useCustomSneakbar';
import { CModal } from '@coreui/react';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../../hooks/useAuthorizedRequest';
import { generateAxiosInstanceSection } from '../../hooks/useAuthorizedRequestForSection';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import { useNavigate } from 'react-router-dom';
import JsonToExcelDownloader from '../../components/JsonToExcelDownloader';
import { GeneratePdf } from '../../components/GeneratePdf';
import separator_line from "../../assets/separator_line.png";
import { getCurrentTime } from '../../components/CurrentTime';
import { Loader } from '../../components/ModalsCommonFunctions';

const SectionStudentReport = () => {
    const authorizedAxios = generateAxiosInstance()
    const authorizedAxiosSection = generateAxiosInstanceSection()
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()
    const instituteMasterId = localStorage.getItem("instituteMasterId")
    const sectionMasterId = localStorage.getItem("sectionMasterId")

    const initialFormState = {
        sectionMasterId: sectionMasterId,
        instituteMasterId: instituteMasterId,
        academicYearMasterId: '',
        instituteGradeMasterId: '',
        instituteDivisionMasterId: '',
        studentId: '',
        test_type_id: ''
    }
    const [examType, setExamType] = useState()
    const [gradeList, setGradeList] = useState([])
    const [divisionList, setDivisionList] = useState([])
    const [yearList, setYearList] = useState([])
    const [studentList, setStudentList] = useState([])
    const [examDetails, setExamDetails] = useState([])
    const [summaryDetails, setSummaryDetails] = useState([])
    const [reportData, setReportData] = useState(initialFormState)
    const [studentReport, setStudentReport] = useState([])
    const [editId, setEditId] = useState(null)
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getExamType()
        getGradeList()
        getYearList()
    }, []);

    const getExamType = () => {
        const apiUrl3 = `/get-exam-master`;
        authorizedAxios && authorizedAxios.get(apiUrl3)
            .then(response => {
                setExamType(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const getGradeList = () => {
        const apiUrlForSyllabus = `/get-institute-grade?instituteMasterId=${instituteMasterId}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrlForSyllabus)
            .then(response => {
                setGradeList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const getYearList = () => {
        const apiUrlForSyllabus = `/active-academic-years`;
        authorizedAxios && authorizedAxios.get(apiUrlForSyllabus)
            .then(response => {
                setYearList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleInputChange = (e) => {
        setReportData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value
            }
        })
    }

    const handleGradeChange = (e) => {
        setReportData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                instituteDivisionMasterId: '',
                studentId: '',
            }
        })
        setStudentList([]);

        const apiUrlForSyllabus = `/grade-wise-division?instituteMasterId=${instituteMasterId}&instituteGradeMasterId=${e.target.value}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrlForSyllabus)
            .then(response => {
                setDivisionList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleDivisionChange = (e) => {
        const { name, value } = e.target;
        setReportData((prevData) => {
            return {
                ...prevData,
                [name]: value,
                studentId: ''
            }
        })
        const apiUrlForSyllabus = `/get-student-details-report?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}&academicYearMasterId=${reportData.academicYearMasterId}&instituteGradeMasterId=${reportData.instituteGradeMasterId}&instituteDivisionMasterId=${value}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrlForSyllabus)
            .then(response => {
                setStudentList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.log(errorMsg);
            });
    }

    //error
    const initialErrorState = {

    }
    const [error, setError] = useState(initialErrorState)
    const validateForm = () => {
        const noError = Object.values(error).every((error) => error === '');

        const allValuesValid = Object.keys(reportData).every((key) => {
            if (key === 'test_type_id') return true;
            const value = reportData[key];
            return typeof value === "string" ? value !== '' : value.length !== 0;
        });

        return noError && allValuesValid;
    };

    useEffect(() => {
        if (!Object.values(error).every((error) => error === '')) {
            for (const [key, value] of Object.entries(reportData)) {
                if (key === "test_type_id") continue;
                if (value === '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }, [reportData])

    const groupAndSortExamsBySubjectName = (exams) => {
        const groupedExams = exams.reduce((acc, exam) => {
            const subject = exam.subjectName;
            if (!acc[subject]) {
                acc[subject] = [];
            }
            acc[subject].push(exam);
            return acc;
        }, {});

        return Object.keys(groupedExams)
            .sort()
            .map(subjectName => groupedExams[subjectName]);
    }

    const calculateSubjectStatistics = (data) => {
        // Step 1: Aggregate totalMarks and totalExamMarks separately by subjectName
        const subjectTotals = {};

        data.flat().forEach(entry => {
            const { subjectName, totalMarks, totalExamMarks } = entry;
            if (!subjectTotals[subjectName]) {
                subjectTotals[subjectName] = {
                    totalMarks: 0,
                    totalExamMarks: 0
                };
            }
            subjectTotals[subjectName].totalMarks += totalMarks;
            subjectTotals[subjectName].totalExamMarks += totalExamMarks;
        });

        // Step 2: Create new objects with subjectName, totalObtainedMarks, and totalMaximumMarks
        const result = Object.entries(subjectTotals).map(([subjectName, totals]) => ({
            subjectName,
            totalObtainedMarks: totals.totalMarks,
            totalMaximumMarks: totals.totalExamMarks,
            percentage: (totals.totalMarks / totals.totalExamMarks * 100).toFixed(2) // Calculate percentage and fix to 2 decimal places
        }));

        return result;
    }

    const showReport = () => {
        if (validateForm()) {
            setLoading(true);
            let apiUrl = `/student-wise-report?student_id=${reportData.studentId}&`;

            if (reportData.test_type_id.length !== 0) {
                apiUrl += `test_type_id=${reportData.test_type_id}`
            }
            apiUrl = apiUrl.replace(/&$/, '');

            authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
                .then(response => {
                    const data = response.data;
                    const exam_Details = groupAndSortExamsBySubjectName(data.results);
                    const summary = calculateSubjectStatistics(exam_Details);
                    setExamDetails(exam_Details);
                    setStudentReport(data);
                    setSummaryDetails(summary);
                })
                .catch(error => {
                    setStudentReport(error?.response?.data.results);
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire({
                        text: errorMsg
                    })
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        } else {
            for (const [key, value] of Object.entries(reportData)) {
                if (key === "test_type_id") continue;
                if (value == '' || value.length == 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                }
                else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }

    const handleInputReset = () => {
        setStudentReport([]);
        setEditId('');
        setReportData(initialFormState);
        setError(initialErrorState);
    }

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb my-0 ms-2">
                        <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/section-dashboard')}>
                            <span>Dashboard</span>
                        </li>
                        <li className="breadcrumb-item active"><span>Student Report</span></li>
                    </ol>
                </nav>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-pen"></i>Student Report</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">

                                                <div className="col-md-6">
                                                    <label for="academicYearMasterId" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Year :</label>
                                                    <select class="form-select" aria-label="Default select example" name='academicYearMasterId' onChange={handleInputChange} value={reportData.academicYearMasterId}>
                                                        <option selected value={''} disabled>Select Year</option>
                                                        {
                                                            yearList?.map((year) => {
                                                                return <option value={year.id}>{year.yearName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.academicYearMasterId && <p style={{ color: 'red' }}>{error.academicYearMasterId}</p>}
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="instituteGradeMasterId" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Class :</label>
                                                    <select class="form-select" aria-label="Default select example" name='instituteGradeMasterId' onChange={handleGradeChange} value={reportData.instituteGradeMasterId}>
                                                        <option selected value={''} disabled>Select Class</option>
                                                        {
                                                            gradeList?.map((grade) => {
                                                                return <option value={grade.id}>{grade.gradeName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.instituteGradeMasterId && <p style={{ color: 'red' }}>{error.instituteGradeMasterId}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="instituteDivisionMasterId" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Division :</label>
                                                    <select class="form-select" aria-label="Default select example" name='instituteDivisionMasterId' onChange={handleDivisionChange} value={reportData.instituteDivisionMasterId}>
                                                        <option selected value={''} disabled>Select Division</option>
                                                        {
                                                            divisionList?.map((division) => {
                                                                return <option value={division.id}>{division.divisionName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.instituteDivisionMasterId && <p style={{ color: 'red' }}>{error.instituteDivisionMasterId}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="studentId" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Student :</label>
                                                    <select class="form-select" aria-label="Default select example" name='studentId' onChange={handleInputChange} value={reportData.studentId}>
                                                        <option selected value={''} disabled>Select Student</option>
                                                        {
                                                            studentList?.map((student) => {
                                                                return <option value={student.id}>{student.studentName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.studentId && <p style={{ color: 'red' }}>{error.studentId}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Exam Type  :</label>
                                                    <select class="form-select" aria-label="Default select example" name='test_type_id' onChange={handleInputChange} value={reportData.test_type_id}>
                                                        <option selected value={''} disabled>Select Exam Type</option>
                                                        {
                                                            examType?.map((exam) => {
                                                                return <option value={exam.id}>{exam.examName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.test_type_id && <p style={{ color: 'red' }}>{error.test_type_id}</p>}
                                                </div>

                                            </div>

                                            <div className="row">
                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                    <div className="col-auto">
                                                        <button className="btn btn-primary " style={{ marginRight: '20px' }} type="button" onClick={showReport}>Show</button>
                                                        <button className="btn btn-danger delete_icon" type="button" style={{ marginRight: "20px" }} onClick={handleInputReset}>Reset</button>
                                                    </div>
                                                </div>

                                                <div className="separator"></div>
                                                {studentReport && Object.keys(studentReport).length !== 0 ? (
                                                    <>
                                                        <GeneratePdf id="examReportContent" />
                                                        <div className="d-grid gap-2 mt-2">
                                                            <div class="report_block" id='examReportContent'>
                                                                <div class="heading">
                                                                    <div class="logo">
                                                                        <img src={studentReport?.studentDetails?.sectionMasterDetails?.logoPath} alt="" />
                                                                    </div>
                                                                    {/* <h3 class="text_center">{studentReport.studentDetails.instituteMasterDetails.instituteName}</h3>
                                                                    <h5 className='text_center'>Section: {studentReport.studentDetails.sectionMasterDetails.sectionName}</h5> */}
                                                                    <div class="text_center">
                                                                        <h6>{studentReport?.studentDetails?.instituteMasterDetails?.instituteName}</h6>
                                                                        <h4>{studentReport?.studentDetails?.sectionMasterDetails?.sectionName}</h4>
                                                                    </div>
                                                                    <div class="logo">
                                                                        <img src={studentReport?.studentDetails?.instituteMasterDetails?.logoPath} alt="" />
                                                                    </div>
                                                                </div>
                                                                <div class="report_code text_center">
                                                                    {/* <span className="line"></span> */}
                                                                    <img src={separator_line} alt="" className="line" />
                                                                    <span className="txt">Student Exam Report</span>
                                                                </div>
                                                                {/* <div class="report_head">
                                                                    <span>Section: {studentReport.studentDetails.sectionMasterDetails.sectionName}</span>
                                                                    <span>Board: Board name</span>
                                                                    <span>Medium: Medium name</span>
                                                                </div> */}
                                                                <div class="candidate_details">
                                                                    <span class="table_caption">Student Details</span>
                                                                    <table>
                                                                        <tbody>
                                                                            <tr>
                                                                                <td width="50%">
                                                                                    <ul>
                                                                                        <li>
                                                                                            <b>Student ID: </b>
                                                                                            <span>{studentReport?.studentDetails?.studentId}</span>
                                                                                        </li>
                                                                                        <li>
                                                                                            <b>Student Name: </b>
                                                                                            <span>{studentReport?.studentDetails?.studentName}</span>
                                                                                        </li>
                                                                                        <li>
                                                                                            <b>Gender: </b>
                                                                                            <span>{studentReport?.studentDetails?.gender}</span>
                                                                                        </li>
                                                                                        <li>
                                                                                            <b>Pincode: </b>
                                                                                            <span>{studentReport?.studentDetails?.pincode}</span>
                                                                                        </li>
                                                                                        <li>
                                                                                            <b>Address: </b>
                                                                                            <span>{studentReport?.studentDetails?.address}</span>
                                                                                        </li>
                                                                                        <li>
                                                                                            <b>Date of Birth: </b>
                                                                                            <span>{studentReport?.studentDetails?.dob}</span>
                                                                                        </li>
                                                                                    </ul>
                                                                                </td>
                                                                                <td width="50%">
                                                                                    <ul>
                                                                                        <li>
                                                                                            <b>Academic Year: </b>
                                                                                            <span>{studentReport?.studentDetails?.academicYearMasterDetails?.yearName}</span>
                                                                                        </li>
                                                                                        <li>
                                                                                            <b>Registration No: </b>
                                                                                            <span>{studentReport?.studentDetails?.regis_no}</span>
                                                                                        </li>
                                                                                        <li>
                                                                                            <b>Class: </b>
                                                                                            <span>{studentReport?.studentDetails?.instituteGradeMasterDetails?.gradeName}</span>
                                                                                        </li>
                                                                                        <li>
                                                                                            <b>Division: </b>
                                                                                            <span>{studentReport?.studentDetails?.instituteDivisionMasterDetails?.divisionName}</span>
                                                                                        </li>
                                                                                        <li>
                                                                                            <b>Contact No: </b>
                                                                                            <span>{studentReport?.studentDetails?.primaryContact}, {studentReport?.studentDetails?.secondaryContact}</span>
                                                                                        </li>
                                                                                    </ul>
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>

                                                                <div class="analysis_report">
                                                                    <span class="table_caption">Exam Details</span>
                                                                    <table>
                                                                        <thead>
                                                                            <tr>
                                                                                <th>Subject Name</th>
                                                                                <th>Exam Name</th>
                                                                                <th>Obtained Marks</th>
                                                                                <th>Passing Marks</th>
                                                                                <th>Total Exam Marks</th>
                                                                                <th>%</th>
                                                                                <th>Remarks</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {
                                                                                examDetails.map((exams) => (
                                                                                    <>
                                                                                        <tr>
                                                                                            <td rowSpan={exams.length}>{exams[0].subjectName}</td>
                                                                                            <td>{exams[0].exam_name}</td>
                                                                                            <td>{exams[0].totalMarks}</td>
                                                                                            <td>{exams[0].passingMarks}</td>
                                                                                            <td>{exams[0].totalExamMarks}</td>
                                                                                            <td>{exams[0].percentage < 0 ? 0 : exams[0].percentage}</td>
                                                                                            <td>{exams[0].passOrFail}</td>
                                                                                        </tr>

                                                                                        {
                                                                                            exams.slice(1).map((exam) => (
                                                                                                <tr>
                                                                                                    <td>{exam.exam_name}</td>
                                                                                                    <td>{exam.totalMarks}</td>
                                                                                                    <td>{exam.passingMarks}</td>
                                                                                                    <td>{exam.totalExamMarks}</td>
                                                                                                    <td>{exam.percentage < 0 ? 0 : exam.percentage}</td>
                                                                                                    <td>{exam.passOrFail}</td>
                                                                                                </tr>
                                                                                            ))
                                                                                        }
                                                                                    </>
                                                                                ))
                                                                            }
                                                                        </tbody>
                                                                    </table>
                                                                </div>

                                                                <div class="analysis_report">
                                                                    <span class="table_caption">Summary Details</span>
                                                                    <table>
                                                                        <thead>
                                                                            <tr>
                                                                                <th>Subject Name</th>
                                                                                <th>Total Obtained Marks</th>
                                                                                {/* <th>Passing Marks</th> */}
                                                                                <th>Total Maximum Marks</th>
                                                                                <th>%</th>
                                                                                {/* <th>Remarks</th> */}
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {
                                                                                summaryDetails.map((subject) => (
                                                                                    <tr>
                                                                                        <td>{subject.subjectName}</td>
                                                                                        <td>{subject.totalObtainedMarks}</td>
                                                                                        <td>{subject.totalMaximumMarks}</td>
                                                                                        <td>{subject.percentage < 0 ? 0 : subject.percentage}</td>
                                                                                    </tr>
                                                                                ))
                                                                            }
                                                                        </tbody>
                                                                    </table>
                                                                </div>

                                                                <div class="report_footer">
                                                                    <div class="section_incharge">
                                                                        <span>{studentReport?.studentDetails?.sectionMasterDetails?.sectionInchargeName}</span>
                                                                        <span>Section Incharge Name</span>
                                                                    </div>
                                                                    <div class="institute_head">
                                                                        <span>{studentReport?.studentDetails?.instituteMasterDetails?.inchargeName}</span>
                                                                        <span>Institute Head Name</span>
                                                                    </div>
                                                                    <div class="timestamp">
                                                                        <span>{getCurrentTime()}</span>
                                                                        <span>Time stamp of export</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>
                                                ) : (
                                                    <div className="text-center" style={{ padding: "50px", fontWeight: 'bold' }}>
                                                        No Report Available
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default SectionStudentReport;